import { z } from "zod";
import { ActorRefSchema, LocalizedTextSchema, TimestampSchema } from "./common.js";
import { IdSchema, TypeNameSchema } from "./ids.js";
export const Vec3Schema = z.tuple([z.number(), z.number(), z.number()]);
export const QuatSchema = z.tuple([z.number(), z.number(), z.number(), z.number()]);
export const TransformSchema = z.object({
    position: Vec3Schema,
    rotation: QuatSchema,
    scale: Vec3Schema.optional(),
});
/** Everything in Uzverse is an entity (DESIGN §2). State is a projection of the event log. */
export const EntitySchema = z.object({
    id: IdSchema,
    /** null = world-scoped. */
    companyId: IdSchema.nullable(),
    type: TypeNameSchema,
    parentId: IdSchema.nullable(),
    /** Validated by the owning module's schema. */
    props: z.record(z.string(), z.unknown()),
    transform: TransformSchema.optional(),
    /** Optimistic concurrency: starts at 1, +1 per change. */
    version: z.number().int().positive(),
    createdBy: ActorRefSchema,
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
    /** Soft delete (trash). */
    deletedAt: TimestampSchema.nullable(),
});
/** The mutable part of an entity, recorded before/after in `entity.updated` events. */
export const EntityStateSchema = z.object({
    parentId: IdSchema.nullable(),
    props: z.record(z.string(), z.unknown()),
    transform: TransformSchema.nullable(),
});
/** Declarative render hints for clients (Phase 2 3D uses these; shape is open for now). */
export const RenderHintsSchema = z.record(z.string(), z.unknown());
/** Declarative UI hints (list columns, icons, forms). Shape is open for now. */
export const UiHintsSchema = z.record(z.string(), z.unknown());
export const EntityTypeDefMetaSchema = z.object({
    type: TypeNameSchema,
    label: z.object({ singular: LocalizedTextSchema, plural: LocalizedTextSchema }),
    parentTypes: z.array(TypeNameSchema).optional(),
    personalProps: z.array(z.string()).optional(),
    render: RenderHintsSchema.optional(),
    ui: UiHintsSchema.optional(),
});
//# sourceMappingURL=entity.js.map